import Button from "@/components/inputs/button";
import Rodape from "@/features/Rodape";
import Image from "next/image";
import styled from "styled-components";
import Events from "@/utils/Events";

const Divisor = styled.div`
width: 328px;
height: 0;
margin: 16px 0.3px 0 0;
border: solid 1px #19519e;
`
const Text404 = styled.p`
font-size: 18px;
color: #777777;
text-align: center;
margin-top: -5px;
line-height: 1.4;
a {
color: #2575e8;
font-weight:600;
text-decoration: underline;
}
`
const Div404 = styled.div`
width: 340px;  
display:flex; 
justify-content: center;
align-items: center;
flex-direction: column;
`
const NotFoundOfferText = styled.h1`
color: #777777;
font-weight: 700; 
font-style: italic; 
font-size: 42px;
text-align: center;
`
const MarginImage = styled.div`
margin-top: 36px;
`
const DivButton = styled.div`
width: 100%
`
const LogoDiv = styled.div`
padding: 15px;
text-align: center
`
export default function ClientError() {
    const events = new Events(); 
    if (typeof window != "undefined") {
        window.setTimeout(function(){ events.trigger("pagina_error_client_visualizado", {show: true}) },1000);
        }
    return (
        <Div404>
            <div>
            <LogoDiv>
                 <Image src={'/imgs/logo-estadao.svg'} alt={'Logo Estadão'} width={115} height={25}></Image>
            </LogoDiv>
            <Divisor/>
            </div>
            <MarginImage>
                <Image src={'/imgs/news_img.webp'} alt="news icon" width={180} height={200}></Image> 
            </MarginImage>
            <NotFoundOfferText>Ops, tivemos uma instabilidade!</NotFoundOfferText>
            <Text404>Entre em contato com a nossa Central de Vendas por telefone ou WhatsApp. <br/>
            <a  onClick={()=> events.trigger("pagina_404_televendas_telefone", {show:true})} href="tel:0800 770 2166">0800 770 2166</a> <br/>
            Falar com atendente via <a onClick={()=> events.trigger("pagina_404_televendas_whatsapp", {show:true})} target="_blank" href="https://api.whatsapp.com/send?phone=5511992482333&text&source&data"> WhatsApp</a></Text404>
            <DivButton onClick={()=>events.trigger("pagina_404_ofertas", {show:true})}>
                <a target="_blank" href="https://ofertas.estadao.com.br/"><Button style={{background:'#329e2d'}}>CONFIRA OFERTAS IMPERDÍVEIS!</Button></a>
            </DivButton>
            <p>ou</p>
            <DivButton onClick={()=>{events.trigger("pagina_error_client", {show:true});window.location.reload()}}>
                <a target="_blank" href="javascript:void(0)"><Button style={{background:'#3185ea'}}>TENTAR NOVAMENTE!</Button></a>
            </DivButton>
            <Rodape/>
        </Div404>
    );
}